import { forwardRef, useCallback, useMemo, useState } from "react";

import { cn } from "@/lib/chillnn/cn";

import { Button } from "@/components/ui/button/button";
import Visibility from "@/components/ui/icon/visibility";
import VisibilityOff from "@/components/ui/icon/visibility-off";
import { Input } from "@/components/ui/input/input";

import { FormErrorMessage, FormItem, FormLabel } from "../../../_base/form";

import type { InputHTMLAttributes, ReactNode } from "react";

type Props = {
	textAlign?: "left" | "center" | "right";

	className?: string;

	errorMessage?: string;
	label?: ReactNode;
} & InputHTMLAttributes<HTMLInputElement>;

/**
 * パスワード入力フィールドコンポーネント
 */
export const InputPasswordFieldNew = forwardRef<HTMLInputElement, Props>(
	({ className = "", errorMessage, label, textAlign, ...props }: Props, ref) => {
		const textAlignStyle = useMemo(
			() => (textAlign === "center" ? "text-center" : textAlign === "right" ? "text-right" : "text-left"),
			[textAlign],
		);

		const [isShowPassword, setIsShowPassword] = useState(false);
		const handleClickPasswordButton = useCallback(() => {
			setIsShowPassword((prev) => !prev);
		}, []);
		const passwordButtonTooltip = useMemo(
			() => (isShowPassword ? "パスワードを非表示にする" : "パスワードを表示する"),
			[isShowPassword],
		);

		return (
			<FormItem className={className}>
				<FormLabel>{label}</FormLabel>
				<div className="relative">
					<Input
						type={isShowPassword ? "text" : "password"}
						className={cn(textAlignStyle, "min-w-[110px] tracking-widest")}
						{...props}
						ref={ref}
					/>

					<Button
						className="absolute right-1 top-1/2 -translate-y-1/2 transform bg-transparent"
						variant="no-outline"
						size="icon"
						type="button"
						tooltip={passwordButtonTooltip}
						onClick={handleClickPasswordButton}
					>
						{isShowPassword ? <Visibility /> : <VisibilityOff />}
					</Button>
				</div>
				<FormErrorMessage>{errorMessage}</FormErrorMessage>
			</FormItem>
		);
	},
);
